<div
  *ngIf="showSpinner"
  class="spinner-container-big"
>
  <mat-progress-spinner
    class="spinner"
    [mode]="'indeterminate'"
  >
  </mat-progress-spinner>
</div>
